import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

let RewardDetail = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  let [all, setAll] = useState(0);
  let [used, setUsed] = useState(0);
  let [notused, setnotUsed] = useState(0);
  let [expired, setExpired] = useState(0);
  let [notscratchyet, setnotscratchyet] = useState(0);

  useEffect(() => {
    Start();
    // Payment();
    RewardDeath();
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let RewardDeath = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/rewarddetail",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          if (dat.data.status === true) {
            setData(dat.data.data);

            let expireds = 0;
            let alls = 0;
            let notuseds = 0;
            let useds = 0;
            let notscratchs = 0;

            dat?.data?.data.map((dd, key) => {
              alls = alls + Number(dd?.rewardid?.offer);
              if (dd?.pay === true) {
                useds = useds + Number(dd?.rewardid?.offer);
              } else if (
                calculateDate(Number(dd?.rewardid?.exptime), dd?.createdAt) ===
                  0 &&
                dd?.used === true
              ) {
                notuseds = notuseds + Number(dd?.rewardid?.offer);
              } else if (
                calculateDate(Number(dd?.rewardid?.exptime), dd?.createdAt) ===
                  1 &&
                dd?.used === true
              ) {
                expireds = expireds + Number(dd?.rewardid?.offer);
              } else if (
                calculateDate(Number(dd?.rewardid?.exptime), dd?.createdAt) ===
                  0 &&
                dd?.used === false
              ) {
                notscratchs = notscratchs + Number(dd?.rewardid?.offer);
              } else {
                expireds = expireds + Number(dd?.rewardid?.offer);
              }
            });

            setnotscratchyet(notscratchs);
            setExpired(expireds);
            setnotUsed(notuseds);
            setUsed(useds);
            setAll(alls);
          } else {
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      sub: "",
      exptime: "",
      offertype: "percentage", // default to percentage
      offer: "",
      usertype: "", // default to all
      categorybbps: "",
      rentavaliable: false,
      active: false,
      min: "",
      max: "",
      presentage_avaliable: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      min: Yup.string().required("Min is required"),
      max: Yup.string().required("Max is required"),
      sub: Yup.string().required("Sub is required"),
      exptime: Yup.string().required("Expiration time is required"),
      offertype: Yup.string().required("Offer type is required"),
      offer: Yup.number().required("Offer is required"),
      usertype: Yup.string().required("User type is required"),
      categorybbps: Yup.string().required("Category BBPS is required"),
      presentage_avaliable: Yup.string().required(
        "presentage_avaliable BBPS is required"
      ),
    }),
    onSubmit: (values) => {
      // Handle form submission
      console.log("Form Data:", values);
    },
  });

  const inputStyle = {
    margin: "5px 0",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "5px",
    fontWeight: "700",
  };

  const errorStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "5px",
  };

  const containerStyle = {
    display: "flex",
    gap: "20px",
    padding: "20px",
    textAlign: "left",
  };

  const sectionStyle = {
    flex: 1,
  };

  const formSectionStyle = {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "20px",
    marginBottom: "20px",
  };

  function calculateDates(daysToAdd) {
    console.log(daysToAdd, "daysToAdddaysToAdddaysToAdddaysToAdd");
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + daysToAdd);

    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = currentDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function calculateDate(daysToAdd, createdat) {
    const currentDate = new Date();
    const targetDate = new Date(createdat);
    targetDate.setDate(targetDate.getDate() + daysToAdd);

    // Compare the targetDate with the currentDate
    if (targetDate < currentDate) {
      return 1; // Target date is in the past
    } else {
      return 0; // Target date is today or in the future
    }
  }

  function calculateDatetarget(daysToAdd, createdat) {
    const currentDate = new Date();
    const targetDate = new Date(createdat);
    targetDate.setDate(targetDate.getDate() + daysToAdd);

    const day = String(targetDate.getDate()).padStart(2, "0");
    const month = String(targetDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = targetDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const tabRef = useRef(null);

  // Function to handle tab click
  const handleTabClick = (event) => {
    if (event.target.id === "profile-tab") {
    } else if (event.target.id === "contact-tab") {
    } else if (event.target.id === "used-tab") {
    } else {
    }
  };

  useEffect(() => {
    const tabElement = tabRef.current;

    const handleTabChange = (event) => {
      console.log(event.target.id);
    };

    // Add event listener for tab shown.bs.tab
    tabElement.addEventListener("shown.bs.tab", handleTabChange);

    return () => {
      // Cleanup the event listener when the component unmounts
      tabElement.removeEventListener("shown.bs.tab", handleTabChange);
    };
  }, []);

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }} >
          <div className="d-flex justify-content-between">
            <h1 style={{ textAlign: "center", fontSize: 23 }} className="mt-4">
              Reward Detail
            </h1>
            <div style={{ padding: 10 }}></div>
          </div>
          <div class="container mt-5 w-100">
            <ul
              class="nav nav-tabs w-100 d-flex"
              id="myTab"
              role="tablist"
              style={{ justifyContent: "space-between" }}
              ref={tabRef}
            >
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home"
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                  style={{ fontSize: 20, fontWeight: "700" }}
                  onClick={handleTabClick}
                >
                  All
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                  style={{ fontSize: 20, fontWeight: "700" }}
                  onClick={handleTabClick}
                >
                  Active
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#contact"
                  type="button"
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                  style={{ fontSize: 20, fontWeight: "700" }}
                  onClick={handleTabClick}
                >
                  Expired
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="used-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#used"
                  type="button"
                  role="tab"
                  aria-controls="used"
                  aria-selected="false"
                  style={{ fontSize: 20, fontWeight: "700" }}
                  onClick={handleTabClick}
                >
                  Used
                </button>
              </li>
            </ul>

            <div class="tab-content mt-5" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div className="row">
                  <div className="col-2">
                    <p>All : {all}</p>
                  </div>
                  <div className="col-2">
                    <p>Used : {used}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Used : {notused}</p>
                  </div>
                  <div className="col-2">
                    <p>Expired : {expired}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Scratch Yet : {notscratchyet}</p>
                  </div>
                </div>
                <table class="table table-striped table-hover table-bordered table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Name</th>
                      <th scope="col">Phone No</th>
                      <th scope="col">Reward Given By</th>
                      <th scope="col">Reward Going to Use In</th>
                      <th scope="col">Expire time</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((dd, key) => {
                      return (
                        <>
                          <tr onClick={()=>{
                             navigate("/useralldetail", { state : dd.users })
                          }}>
                            <th scope="row">{key + 1}</th>
                            <td>{dd?.users?.name}</td>
                            <td>{dd?.users?.phoneno}</td>
                            <td>{dd?.rewardid?.usertype}</td>
                            <td>
                              {dd?.rewardid?.rentavaliable === true
                                ? "Rent"
                                : dd?.rewardid?.categorybbps}
                            </td>
                            <td>
                              {calculateDatetarget(
                                Number(dd?.rewardid?.exptime),
                                dd?.createdAt
                              )}
                            </td>
                            <td>{dd?.rewardid?.offer}</td>
                            <td>
                              {dd?.pay === true
                                ? "Used"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === true
                                ? "Not used yet"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 1 && dd?.used === true
                                ? "Expired"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === false
                                ? "Not scratch yet"
                                : "Expired"}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div
                class="tab-pane fade"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div className="row">
                  <div className="col-2">
                    <p>All : {all}</p>
                  </div>
                  <div className="col-2">
                    <p>Used : {used}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Used : {notused}</p>
                  </div>
                  <div className="col-2">
                    <p>Expired : {expired}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Scratch Yet : {notscratchyet}</p>
                  </div>
                </div>
                <table class="table table-striped table-hover table-bordered table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Name</th>
                      <th scope="col">Phone No</th>
                      <th scope="col">Reward Given By</th>
                      <th scope="col">Reward Going to Use In</th>
                      <th scope="col">Expire time</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((dd, key) => {
                      if (
                        dd?.pay === false &&
                        calculateDate(
                          Number(dd?.rewardid?.exptime),
                          dd?.createdAt
                        ) === 0 &&
                        dd?.used === true
                      ) {
                      } else {
                        return;
                      }

                      return (
                        <>
                          <tr onClick={()=>{
                             navigate("/useralldetail", { state : dd.users })
                          }}>
                            <th scope="row">{key + 1}</th>
                            <td>{dd?.users?.name}</td>
                            <td>{dd?.users?.phoneno}</td>
                            <td>{dd?.rewardid?.usertype}</td>
                            <td>
                              {dd?.rewardid?.rentavaliable === true
                                ? "Rent"
                                : dd?.rewardid?.categorybbps}
                            </td>
                            <td>
                              {calculateDatetarget(
                                Number(dd?.rewardid?.exptime),
                                dd?.createdAt
                              )}
                            </td>
                            <td>{dd?.rewardid?.offer}</td>
                            <td>
                              {dd?.pay === true
                                ? "Used"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === true
                                ? "Not used yet"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 1 && dd?.used === true
                                ? "Expired"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === false
                                ? "Not scratch yet"
                                : "Expired"}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div
                class="tab-pane fade"
                id="contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                <div className="row">
                  <div className="col-2">
                    <p>All : {all}</p>
                  </div>
                  <div className="col-2">
                    <p>Used : {used}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Used : {notused}</p>
                  </div>
                  <div className="col-2">
                    <p>Expired : {expired}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Scratch Yet : {notscratchyet}</p>
                  </div>
                </div>
                <table class="table table-striped table-hover table-bordered table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Name</th>
                      <th scope="col">Phone No</th>
                      <th scope="col">Reward Given By</th>
                      <th scope="col">Reward Going to Use In</th>
                      <th scope="col">Expire time</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((dd, key) => {
                      if (
                        dd?.pay === false &&
                        calculateDate(
                          Number(dd?.rewardid?.exptime),
                          dd?.createdAt
                        ) === 1 &&
                        dd?.used === true
                      ) {
                      } else {
                        return;
                      }

                      return (
                        <>
                          <tr onClick={()=>{
                             navigate("/useralldetail", { state : dd.users })
                          }}>
                            <th scope="row">{key + 1}</th>
                            <td>{dd?.users?.name}</td>
                            <td>{dd?.users?.phoneno}</td>
                            <td>{dd?.rewardid?.usertype}</td>
                            <td>
                              {dd?.rewardid?.rentavaliable === true
                                ? "Rent"
                                : dd?.rewardid?.categorybbps}
                            </td>
                            <td>
                              {calculateDatetarget(
                                Number(dd?.rewardid?.exptime),
                                dd?.createdAt
                              )}
                            </td>
                            <td>{dd?.rewardid?.offer}</td>
                            <td>
                              {dd?.pay === true
                                ? "Used"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === true
                                ? "Not used yet"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 1 && dd?.used === true
                                ? "Expired"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === false
                                ? "Not scratch yet"
                                : "Expired"}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div
                class="tab-pane fade"
                id="used"
                role="tabpanel"
                aria-labelledby="used-tab"
              >
                <div className="row">
                  <div className="col-2">
                    <p>All : {all}</p>
                  </div>
                  <div className="col-2">
                    <p>Used : {used}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Used : {notused}</p>
                  </div>
                  <div className="col-2">
                    <p>Expired : {expired}</p>
                  </div>
                  <div className="col-2">
                    <p>Not Scratch Yet : {notscratchyet}</p>
                  </div>
                </div>
                <table class="table table-striped table-hover table-bordered table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Name</th>
                      <th scope="col">Phone No</th>
                      <th scope="col">Reward Given By</th>
                      <th scope="col">Reward Going to Use In</th>
                      <th scope="col">Expire time</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((dd, key) => {
                      if (dd?.pay === true) {
                      } else {
                        return;
                      }
                      return (
                        <>
                          <tr onClick={()=>{
                             navigate("/useralldetail", { state : dd.users })
                          }}>
                            <th scope="row">{key + 1}</th>
                            <td>{dd?.users?.name}</td>
                            <td>{dd?.users?.phoneno}</td>
                            <td>{dd?.rewardid?.usertype}</td>
                            <td>
                              {dd?.rewardid?.rentavaliable === true
                                ? "Rent"
                                : dd?.rewardid?.categorybbps}
                            </td>
                            <td>
                              {calculateDatetarget(
                                Number(dd?.rewardid?.exptime),
                                dd?.createdAt
                              )}
                            </td>
                            <td>{dd?.rewardid?.offer}</td>
                            <td>
                              {dd?.pay === true
                                ? "Used"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === true
                                ? "Not used yet"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 1 && dd?.used === true
                                ? "Expired"
                                : calculateDate(
                                    Number(dd?.rewardid?.exptime),
                                    dd?.createdAt
                                  ) === 0 && dd?.used === false
                                ? "Not scratch yet"
                                : "Expired"}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardDetail;
